import {gql} from 'apollo-boost'

export const GET_CONTRACTS_BY_CURRENT_USER = gql`
  query getContractsByCurrentUser {
    getContractsByCurrentUser{
      id
      contractNo
      contractName
      contractDate
      contractAmount
      contractAmountText
      loanContractFee
      contractFee
      paidContractFee
      loanTaxAmount
      taxAmount
      paidTaxAmount
      restructuring
      restructuringDetail{
        id
        restructuringDate
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        accruedPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        remark
      }
      loan{
        id
        loanType
        loanTypeName
        interestRateEir
        interestRate
        penaltyRate
        period
        paymentDue
        convertInterestAmount
        coDate
        paymentDescription
        loanAmount
				principleRemain
				balanceRemain
				outstandingBalanceRemain

        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain

        accruedPrincipleRemain
				accruedFeeRemain
				accruedPenaltyRemain
				accruedInterestRemain

        contractFeeRemain
        taxAmountRemain
        processingFeeRemain
        courtOrderExpenseRemain

        lastUpdate
        lastUpdateDateTime
        agingNumber
        loanDetails{
          id
          adjustment
          loanDetailType
          transaction{
            id
          }
          loanDate
          seq
          amount
        }
      }
      educationStatus
      contractStatus
      status
    }
  }
`

export const GET_TRANSACTIONS_ACTION_BY_CONTRACT_ID = gql`
  query getTransactionsActionByContractId($contractId: ID!, $filters: FilterInput!) {
    getTransactionsActionByContractId(
      contractId: $contractId,
      filters: $filters
    ) {
      id
      restructuringDetail{
        id
        restructuringDate
        principleRemain
        balanceRemain
        outstandingBalanceRemain
        accruedPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
      }
      loanDetail{
        id
        adjustment
        loanDetailType
        loanDate
        seq
        amount
        remark
        status
      }
      feeDetail{
        id
        adjustment
        feeType
        feeDate
        seq
        amount
        remark
        status
      }
      payment{
        id
        adjustment
        receiveDate
        paymentDate
        paymentAmount
        paymentPrinciple
        paymentRemark
        status
      }
      transactionType
      transactionDate
      transactionDateTime
      principle
      balance
      outstandingBalance
      accruedPrinciple
      accruedFee
      accruedPenalty
      accruedInterest
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPrincipleRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      status
    }
  }
`

export const GET_LAST_PAYMENT_BY_CONTRACT_ID = gql`
  query getLastPaymentByContractId($contractId: ID!) {
    getLastPaymentByContractId(
      contractId: $contractId
    ) {
      id
      adjustment
      receiveDate
      paymentType
      paymentDate
      paymentDateTime
      paymentAmount
      paymentPrinciple
      paymentRemark
      status
    }
  }
`

export const GET_PAYMENT_AMOUNT_DETAIL_BY_CONTRACT_ID = gql`
  query getPaymentAmountDetailByContractId($contractId: ID!, $type: String!, $amount: Float) {
    getPaymentAmountDetailByContractId(
      contractId: $contractId,
      type: $type,
      amount: $amount
    ) {
	    amount
	    paidFee
	    paidPenalty
	    paidInterest
	    paidPrinciple
    }
  }
`

export const GET_PAYMENT_ROUND_DETAIL_BY_CONTRACT_ID = gql`
  query getPaymentRoundDetailByContractId($contractId: ID!) {
    getPaymentRoundDetailByContractId(
      contractId: $contractId
    ) {
      paymentRoundType
      paymentRoundDate
      firstPaymentRoundDate
      nextPaymentRoundDate
      lastPaymentRoundDate
    }
  }
`

export const CREATE_QR_PAYMENT = gql`
  mutation createQrPayment($contractId: ID!, $payload: QrPaymentInput!) {
    createQrPayment(
      contractId: $contractId,
      payload: $payload,
    ) {
      taxId
      suffix
      ref1
      ref2

      paidFee
	    paidPenalty
	    paidInterest
	    paidPrinciple
      balanceRemain

	    paidContractFee
	    paidTaxAmount
      paidProcessingFee
      paidCourtOrderExpense
      dueDate(local: true, format: "DD MMM YYYY HH:mm น.")
      amount
      createdAt
    }
  }
`
